jQuery('.custom_pdf_link').prependTo('.article-actions ul.menu');
jQuery('.associated-document').prependTo('.article-actions ul.menu');